// «Светофор ИИ»: пороги, по которым сводка ИИ красит цех в жёлтый и красный.
// Правит админ клиента (API: GET/PUT /ai/thresholds/). Нет сохранённых значений —
// действуют обычные 5 / 15 % и 90 / 240 мин; кнопка «Вернуть обычные» их подставляет.
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { aiThresholdsAPI } from '../api';

const FIELDS = [
  { key: 'defect_warn_pct', label: 'Брак: жёлтый от, %',
    hint: 'Доля листов не высшего сорта за сутки, начиная с которой цех становится жёлтым.', step: '0.1', max: 100 },
  { key: 'defect_bad_pct', label: 'Брак: красный от, %',
    hint: 'С этой доли не высшего сорта цех красный. Должна быть больше жёлтой.', step: '0.1', max: 100 },
  { key: 'idle_warn_min', label: 'Простой: жёлтый от, мин',
    hint: 'Суммарный простой прессов цеха за сутки, с которого цех жёлтый (90 мин = 1,5 часа).', step: '1', max: 1440 },
  { key: 'idle_bad_min', label: 'Простой: красный от, мин',
    hint: 'С такого простоя за сутки цех красный (240 мин = 4 часа). Должен быть больше жёлтого.', step: '1', max: 1440 },
];

export default function AiThresholdsPanel() {
  const [form, setForm] = useState(null);
  const [defaults, setDefaults] = useState({});
  const [meta, setMeta] = useState({});
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const apply = (d) => {
    setForm(Object.fromEntries(FIELDS.map(f => [f.key, String(d[f.key])])));
    setDefaults(d.defaults || {});
    setMeta({ by: d.updated_by, at: d.updated_at, custom: d.custom });
  };

  useEffect(() => {
    aiThresholdsAPI.get().then(r => apply(r.data))
      .catch(() => setErr('Не удалось загрузить пороги'));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await aiThresholdsAPI.save(form);
      apply(r.data);
      toast.success('Пороги сохранены');
    } catch (x) {
      setErr((x.response && x.response.data && x.response.data.detail) || 'Не удалось сохранить');
    } finally { setBusy(false); }
  };

  if (!form) return <p style={{ color: 'var(--dim)' }}>{err || 'Загружаю…'}</p>;

  const inp = {
    width: '100%', boxSizing: 'border-box', padding: '12px 14px', fontSize: 16,
    background: 'var(--input)', border: '1px solid var(--border)', borderRadius: 8,
    color: 'var(--text)', fontFamily: 'inherit',
  };
  return (
    <form onSubmit={save} style={{ maxWidth: 520, width: '100%', margin: '0 auto', padding: '0 4px' }}>
      <h2 style={{ fontSize: 18, margin: '0 0 6px' }}>🚦 Светофор ИИ</h2>
      <p style={{ color: 'var(--dim)', fontSize: 14, margin: '0 0 16px', overflowWrap: 'break-word' }}>
        По этим порогам сводка ИИ красит цех. Если цифры не заданы, действуют обычные.
      </p>
      {err && <div style={{ color: '#ef4444', marginBottom: 12, fontSize: 14 }}>{err}</div>}
      {FIELDS.map(f => (
        <div key={f.key} style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontWeight: 600, fontSize: 14, marginBottom: 6 }}>{f.label}</label>
          <input type="number" inputMode="decimal" min="0" max={f.max} step={f.step} required
                 value={form[f.key]} style={inp}
                 onChange={e => setForm({ ...form, [f.key]: e.target.value })} />
          <div style={{ color: 'var(--dim)', fontSize: 13, marginTop: 4, overflowWrap: 'break-word' }}>
            {f.hint} Обычно: {defaults[f.key]}.
          </div>
        </div>
      ))}
      <button disabled={busy} style={{
        width: '100%', minHeight: 48, borderRadius: 10, border: 'none', fontSize: 16, fontWeight: 700,
        background: 'var(--accent)', color: '#fff', cursor: 'pointer', fontFamily: 'inherit',
      }}>{busy ? 'Сохраняю…' : 'Сохранить'}</button>
      {meta.custom && meta.by && (
        <p style={{ color: 'var(--dim)', fontSize: 12, marginTop: 10 }}>
          Менял: {meta.by}{meta.at ? `, ${new Date(meta.at).toLocaleString('ru-RU')}` : ''}
        </p>
      )}
    </form>
  );
}
